import React from 'react';

export default function FiscalPeriod() {
  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-4">Fiscal Period</h1>
      <p className="text-gray-500">Halaman Fiscal Period</p>
    </div>
  );
}
